module.exports = "<datepicker ng-model='model[options.key]' ng-required=\"to.required\" options=\"options\"></datepicker>"


/*****************
 ** WEBPACK FOOTER
 ** ./src/templates/formly/dateInput.html
 ** module id = 535
 ** module chunks = 0
 **/